import { TabsWithContent, useSessionStorage } from "@homebound/beam";
import { useState } from "react";
import { LotOverviewPageLotFragment } from "src/generated/graphql-types";
import { InvestorMarginDetails } from "./InvestorMarginDetails";
import { LotPartitionsTable } from "./LotPartitionsTable";
import { LotDocumentsTable } from "./LotDocumentsTable";
import { DirectUnderwritingLotPartitionsTable } from "./DirectUnderwritingLotPartitionsTable";

export type LotOverviewTabsProps = {
  lot: LotOverviewPageLotFragment;
};

export function LotOverviewTabs({ lot }: LotOverviewTabsProps) {
  const [currentTab, setCurrentTab] = useSessionStorage("lotOverviewTab", "InvestorMarginDetails");
  const tabs = getTabs({ lot });
  return <TabsWithContent selected={currentTab} onChange={setCurrentTab} tabs={tabs} />;
}

function getTabs(props: LotOverviewTabsProps) {
  const { lot } = props;

  const tabs = [
    {
      name: "Investor Margin Details",
      value: "InvestorMarginDetails",
      render: () => <InvestorMarginDetails marginData={lot}></InvestorMarginDetails>,
    },
    {
      name: "Partitions",
      value: "Partitions",
      render: () => <LotPartitionsTable lotPartitions={lot.partitions} lot={lot}></LotPartitionsTable>,
    },
    {
      name: "Documents",
      value: "Documents",
      render: () => <LotDocumentsTable lot={lot}></LotDocumentsTable>,
    },
  ];

  // We only show the Direct Underwriting tab if the lot is suburban since those are the only lots that have direct underwriting contracts - the rest are done via the UW App
  if (lot.isSuburban) {
    tabs.push({
      name: "Direct Underwriting",
      value: "Direct Underwriting",
      render: () => (
        <DirectUnderwritingLotPartitionsTable
          lotPartitions={lot.partitions}
          lot={lot}
        ></DirectUnderwritingLotPartitionsTable>
      ),
    });
  }
  return tabs;
}
